import { State } from 'common/store/reducers';

export const selectCurrentUrlsPage = (state: State) => state.tags.list.page;

export const selectUrls = (state: State) => state.urls.list.data;

export const selectUrlsLoading = (state: State) => state.urls.list.loading;

export const selectUrlsAmount = (state: State) => state.urls.list.amount;
